import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PickingListLabel, PurchaseOrderLineStockAllocation } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderStockAllocationService extends TmsWebBaseEditCreateService<
  PurchaseOrderLineStockAllocation,
  PurchaseOrderLineStockAllocation
> {
  constructor() {
    super('PurchaseOrderStockAllocation', $localize`Purchase Order Stock Allocation`);
  }

  allocate(purchaseOrderLineRequirementId: string, stockItemId: string): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/Allocate`, {
      purchaseOrderLineRequirementId,
      stockItemId,
    });
  }

  updatePurchaseOrderStockAllocation(purchaseOrderStockAllocationId: string, quantity: number) {
    return this.httpService.post<any>(`${this.apiUrl}/UpdatePurchaseOrderStockAllocation`, {
      purchaseOrderStockAllocationId,
      quantity,
    });
  }

  // takenQuantity: the length just taken from a remnant. A remnant take moves no stock, so the
  // label has no cut movement to read its quantity from and printed blank; the cutting screen
  // passes the length it knows at that moment (4Spaces, 16 Sep 2026). Omitted on a reprint, where
  // the API falls back to the requirement quantity.
  getPickingListLabel(
    purchaseOrderStockAllocationId: any,
    previousLocation: boolean,
    takenQuantity?: number,
  ): Observable<PickingListLabel> {
    const taken = takenQuantity == null ? '' : `&takenQuantity=${takenQuantity}`;

    return this.httpService.get<PickingListLabel>(
      `${this.apiUrl}/GetPickingListLabel?purchaseOrderStockAllocationId=${purchaseOrderStockAllocationId}&previousLocation=${previousLocation}${taken}`,
    );
  }

  getAllocations(purchaseOrderLineId: any): Observable<PurchaseOrderLineStockAllocation[]> {
    return this.httpService.get<PurchaseOrderLineStockAllocation[]>(
      `${this.apiUrl}/GetAllocations?purchaseOrderLineId=${purchaseOrderLineId}`,
    );
  }
}
